import { Link } from 'react-router-dom';
import { PageHero } from '../components/ui/PageHero';
import { AnimatedCard } from '../components/ui/AnimatedCard';
import { CTAButton } from '../components/ui/CTAButton';
import { CONTACT_TYPES, CONTACT_EMAIL, BUSINESS_HOURS } from '../constants/content';
import { contactPath } from '../constants/navigation';

export default function ContactPage() {
  return (
    <>
      <PageHero
        title="联系我们"
        subtitle="商务合作、意见反馈、产品建议，欢迎随时与我们沟通。"
        breadcrumb={[{ label: '首页', path: '/' }, { label: '联系我们' }]}
      />

      <section className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-16">
          {CONTACT_TYPES.map((item) => (
            <Link key={item.id} to={contactPath(item.id)} className="block h-full">
              <AnimatedCard className="bg-white/5 rounded-2xl p-6 border border-purple-500/20 text-center h-full hover:border-purple-500/40">
                <i className={`fa ${item.icon} text-3xl text-secondary mb-3`} />
                <h3 className="font-semibold mb-2">{item.title}</h3>
                <p className="text-purple-300 text-sm mb-3">{item.desc}</p>
                <span className="text-secondary text-sm font-medium">
                  了解详情 →
                </span>
              </AnimatedCard>
            </Link>
          ))}
        </div>

        <div className="max-w-2xl mx-auto bg-gradient-to-r from-primary/20 to-secondary/20 rounded-3xl p-10 backdrop-blur-sm border border-purple-500/20 text-center mb-16">
          <div className="mb-6">
            <i className="fa fa-envelope-o text-5xl text-secondary mb-4" />
          </div>
          <h2 className="text-2xl font-semibold mb-4">官方联系邮箱</h2>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="text-xl text-secondary font-bold hover:underline"
          >
            {CONTACT_EMAIL}
          </a>
          <p className="text-purple-200 mt-6 text-sm leading-relaxed">
            {BUSINESS_HOURS} 邮件均会及时查阅回复
            <br />
            期待与您的合作与宝贵建议
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <h2 className="text-2xl font-bold mb-8 text-center">快捷入口</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <CTAButton to="/inquiry" variant="secondary" icon="fa-shopping-cart" className="w-full">
              购买咨询
            </CTAButton>
            <CTAButton to="/support" variant="secondary" icon="fa-life-ring" className="w-full">
              技术支持
            </CTAButton>
          </div>
        </div>

        <div className="text-center">
          <p className="text-purple-300 text-sm mb-4">需要技术帮助？</p>
          <Link
            to="/support"
            className="inline-flex items-center text-secondary hover:underline"
          >
            前往技术支持 <i className="fa fa-arrow-right ml-2" />
          </Link>
        </div>
      </section>
    </>
  );
}
